import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import cantalLogo from '../assets/cantal.png';

const input: React.CSSProperties = {
  padding: '0.65rem 0.875rem',
  fontSize: '0.95rem',
  borderRadius: '8px',
  border: '1.5px solid #d1d5db',
  width: '100%',
  boxSizing: 'border-box',
  outline: 'none',
  color: '#111827',
  background: '#fff',
};

export default function SetPasswordPage(): JSX.Element {
  const { setupPassword } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email ?? '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!email) {
    void navigate('/login');
    return <></>;
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }
    setSubmitting(true);
    try {
      await setupPassword(email, password);
      void navigate('/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur inconnue.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(145deg, #e8f0fe 0%, #f0f4ff 60%, #fafbff 100%)',
      padding: '1rem',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(30,58,95,0.10), 0 1px 4px rgba(0,0,0,0.05)',
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: '380px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.25rem',
      }}>
        <img src={cantalLogo} alt="Pierroinfo" style={{ height: '72px', width: 'auto' }} />
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 0.375rem', color: '#111827' }}>Bienvenue !</h1>
          <p style={{ color: '#6b7280', margin: 0, fontSize: '0.88rem' }}>
            Première connexion pour <strong style={{ color: '#374151' }}>{email}</strong>.<br />
            Choisissez votre mot de passe.
          </p>
        </div>

        <form onSubmit={(e) => void handleSubmit(e)} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%' }}>
          <input
            type="password"
            placeholder="Mot de passe (8 car. min.)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoFocus
            minLength={8}
            style={input}
          />
          <input
            type="password"
            placeholder="Confirmer le mot de passe"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={input}
          />
          {error && (
            <p style={{ color: '#dc2626', margin: 0, fontSize: '0.85rem', background: '#fef2f2', borderRadius: '6px', padding: '0.5rem 0.75rem' }}>
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            style={{
              padding: '0.7rem 1.2rem',
              fontSize: '0.95rem',
              fontWeight: 600,
              cursor: submitting ? 'not-allowed' : 'pointer',
              borderRadius: '8px',
              border: 'none',
              background: submitting ? '#93c5fd' : '#2563eb',
              color: '#fff',
              width: '100%',
              letterSpacing: '0.01em',
            }}
          >
            {submitting ? 'Enregistrement…' : 'Définir mon mot de passe'}
          </button>
        </form>
      </div>
    </main>
  );
}
